import { DateTime } from 'luxon';
import { Divider, Group, Stack, Text } from 'ui';

export interface EventDateTimeProps {
  startDate: string; // ISO format date string
}

const EventDateTime: React.FC<EventDateTimeProps> = ({ startDate }) => {
  const eventDate = DateTime.fromISO(startDate).toFormat('MMM dd, yyyy');
  const eventTime = DateTime.fromISO(startDate)
    .toFormat('t')
    .replace(' AM', 'am')
    .replace(' PM', 'pm');

  return (
    <Group p="sm">
      <Stack gap={4} p={4} flex={1}>
        <Text fz="xs" c="gray.6">
          Date
        </Text>
        <Text fz="sm" fw={600}>
          {eventDate}
        </Text>
      </Stack>

      <Divider orientation="vertical" />
      <Stack gap={4} p={4} flex={1}>
        <Text fz="xs" c="gray.6">
          Time
        </Text>
        <Text fz="sm" fw={600}>
          {eventTime}
        </Text>
      </Stack>
    </Group>
  );
};

export { EventDateTime };
